import React, { Fragment, useState, useEffect } from "react";
import { Card, Form, Spinner } from "react-bootstrap";
import {  useLocation, useParams } from "react-router-dom";
import Snackbars from "../../../utils/Snackbars";
import useRequests from "../../../utils/useRequests";
import DataTable from "react-data-table-component";


const ListedTicket = () => {
  const location = useLocation();
  const { getRequest } = useRequests();

  const [usersTickets, setUsersTickets] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

 

  const [AlertData, setAlertData] = React.useState({
    variant: '',
    message: '',
  });

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: '',
        message: '',
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const [loading, setLoading] = useState(true);

  const fetchResaleTickets = async () => {
    const response = await getRequest(`resale-tickets`); // Replace "users" with the appropriate API endpoint
    if (response && response.code === 200) {
      const filteredTickets = response.data.filter(ticket => ticket.resale_status !== "Sold");
      setUsersTickets(filteredTickets);
    } else {
      console.error("Failed to fetch users tickets:", response.message);
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: response.message,
      }));
    }
    resetAlertData();
    setLoading(false);
  };

  useEffect(() => {
    fetchResaleTickets();
    if (location.state && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
      setLoading(false);
    }
  }, []);

  // Filter users based on the search query
  const filteredUsers = usersTickets.filter((tickets) => {
    const name = `${tickets.first_name? tickets.first_name+ " "+ tickets.last_name : "N/A"}`.toLowerCase();
    const phone = `${tickets.phone}`.toLowerCase();
    const event = `${tickets.name}`.toLowerCase();
    const duration = `${tickets.duration} day`;
    const quantity = `${tickets.resale_quantity}`;

    const type = `${tickets.type}`.toLowerCase();
    const purchase_price = `${
      tickets.resale_quantity *
      (tickets.purchase_price /
        (Number(tickets.quantity) +
          Number(tickets.resold_quantity)))
    }`.toLowerCase();

    const date = new Date(tickets.purchase_date);
    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const formattedTime = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    });
    const purchase_date = `${formattedDate}`;

    const resale_price = `${Number(tickets.resale_price)}`.toLowerCase();

    const date1 = new Date(tickets.resale_date);
    const formattedDate1 = date1.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const formattedTime1 = date1.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    });
    const resale_date = `${formattedDate1}`;

    let TicketDate;
    if(tickets.duration == "1"){
      TicketDate = tickets.event_ticket_date;
    }else{
      TicketDate = tickets.start_datetime;
    }

    const ticketdate = new Date(TicketDate);
    const formattedticketDate = ticketdate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const ticket_date = `${formattedticketDate}`;
    // const query = {fullName, email};
    // return query.includes(searchQuery.toLowerCase());
    const searchLower = searchQuery.toLowerCase();
  
    return ticket_date.includes(searchQuery) || quantity.includes(searchQuery) || phone.includes(searchQuery) || resale_price.includes(searchQuery) || name.includes(searchLower) || resale_date.includes(searchQuery) ||event.includes(searchLower) || duration.includes(searchLower) || type.includes(searchLower) || purchase_price.includes(searchQuery)|| purchase_date.includes(searchQuery);
  });




  const columns = [
    {
      name: "Full Name",
      selector: (row) => `${row.first_name? row.first_name +" "+row.last_name : "N/A"}`,
      sortable: true,
      width: "200px" 
    },
     {
      name: "Mobile Number",
      selector: (row) => `${row.phone}`,
      sortable: true,
      width: "200px" 
    },
    {
      name: "Event",
      selector: (row) => `${row.name}`,
      sortable: true,
      width: "150px" 
    },
     {
        name: "Duration",
        selector: (row) => `${row.duration} day`,
        sortable: true,
        width: "200px" 
    },
    {
      name: "Type",
      selector: (row) => row.type,
      sortable: true,
    },
    {
      name: "No. of Tickets",
      selector: (row) => `${row.resale_quantity}`,
      sortable: true,
      width: "150px" 
    },
    {
      name: "Seat Number",
      selector: (row) => `${row.is_seats_required === "Yes" ? row.booked_seat : "-"}`,
      sortable: true,
      width: "150px" 
    },
    {
      name: "Purchase Price",
      selector: (row) =>  `${Number(row.resale_quantity) *(row.purchase_price /(Number(row.quantity) + Number(row.resold_quantity)))
      }`,
      sortable: true,
      width: "150px" 
    },
    {
      name: "Purchase Date",
      selector: (row) => {
        const date = new Date(row.purchase_date);
        const formattedDate = date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        const formattedTime = date.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return `${formattedDate}`;
      },
      sortable: true,
      width: "150px" 
    },
    {
      name: "Selling  Price",
      selector: (row) => Number(row.resale_price),
      sortable: true,
      width: "150px" 
    },
    {
      name: "Selling Date",
      selector: (row) => {
        const date = new Date(row.resale_date);
        const formattedDate = date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        const formattedTime = date.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return `${formattedDate}`;
      },
      sortable: true,
      width: "150px" 
    },
    {
      name: "Event Date",
      selector: (row) => {
        let date;
        if(row.duration == "1"){
          date = new Date(row.event_ticket_date);
        }else{
          date = new Date(row.start_datetime);
        }
        const formattedDate = date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        const formattedTime = date.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return `${formattedDate}`;
      },
      sortable: true,
      width: "150px" 
    },
  ];

  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headCells: {
      style: {
        color: "#341439",
        fontSize: "17px",
        fontWeight: "600",
        paddingLeft: "8px", // Adjust padding
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        fontSize: "16px",
        padding: "12px 9px",
        color: "#7E7E7E",
      },
    },
    pagination: {
      style: {
        fontSize: "16px",
      },
    },
  };

  // if (loading) return <p>Fetching data...</p>;

  return (
    <Fragment>
              {AlertData.message !== "" ? (
          <Snackbars variant={AlertData.variant} message={AlertData.message} />
        ) : (
          ""
        )}
      <div className='d-sm-flex d-block justify-content-between align-items-center mb-4'>
        <h2 className='text-black font-w600 mb-0'>Listed Tickets</h2>
      </div>

      {/* Search input */}
      <div className='mb-4 d-sm-flex d-block justify-content-end'>
      <div style={{ position: "relative", width: "18rem" }}>
  <Form.Control
    type="text"
    placeholder="Search..."
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    style={{
      width: "100%",
      fontSize: "18px",
      fontWeight: 500,
      paddingRight: "2rem",
      borderRadius:'0.625rem',
      height:'3.2rem' // Add padding to ensure the icon doesn't overlap text
    }}
  />
  <i
    className="fa fa-search"
    style={{
      position: "absolute",
      right: "10px", // Distance from the right edge of the input
      top: "50%",
      transform: "translateY(-50%)", // Center vertically
      color: "#6c757d", // Optional: color for the icon
      pointerEvents: "none", // Makes sure clicks pass through to the input
    }}
  ></i>
</div>
      </div>

      <Card>
        <Card.Body>
          {loading ? (
                <div className='text-center'>
                  <Spinner animation='border' />
                  <p>Loading settings...</p>
                </div>) : 
          (<DataTable
            columns={columns}
            data={filteredUsers} // Use filtered data
            customStyles={customStyles}
            pagination
            highlightOnHover
            responsive
          />)}
        </Card.Body>
      </Card>

    </Fragment>
  );
};

export default ListedTicket;
